'use strict';

import {
    companyGuard,
    fnToastrFormError,
    getSelectedCompany,
    printResponse,
    toggleSpinnerByParent
} from "../../jquery-functions-library";
import {element_exists} from "../../functions";

export var fnHolidayPayObligationsExport = function () {
    const tableNameEntries = '#datatable-holiday-pay-obligation-entries';
    const tableNameObligations = '#datatable-holiday-pay-obligations';

    if (!element_exists(tableNameEntries) && !element_exists(tableNameObligations)) return false;

    const formName = '.form-create-holiday-pay-obligation-export';

    const $tableEntries = $(tableNameEntries);

    $(document).off('submit', formName).on('submit', formName, function (e) {
        e.preventDefault();

        if (companyGuard()) {
            return;
        }
        const id = $(this).data('id');
        let selectedCompanyId = getSelectedCompany();
        let clientCompanyId = $('body').attr('data-company');

        if (clientCompanyId !== undefined) {
            selectedCompanyId = clientCompanyId;
        }
        const url = `/${selectedCompanyId}/holiday-pay-obligations/${id}/export`;
        const data = $(this).serialize();
        const self = $(this);
        const btnExport = $(this).find('.btn-create-holiday-pay-obligation-export');

        $.confirm({
            title: allLangFiles['holiday-pay-obligations'].entries.economic.export.title,
            content: allLangFiles['holiday-pay-obligations'].entries.economic.export.content,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {
                        console.log('here');
                        toggleSpinnerByParent(self, btnExport);

                        $.ajax({
                            method: 'POST',
                            url: url,
                            data: data,
                            success: function (response) {
                                printResponse(response);
                                if (element_exists(tableNameEntries)) {
                                    $tableEntries.DataTable().ajax.reload(null, false);
                                }

                                toggleSpinnerByParent(self, btnExport);

                            },
                            error: function (data) {
                                fnToastrFormError(data);

                                toggleSpinnerByParent(self, btnExport);
                            }
                        });
                    },
                    text: allLangFiles.forms.yes
                },
                Nej: {
                    text: allLangFiles.forms.no,
                }
            }
        });
    });
};